// tslint:disable
export var LayoutCategory;
(function (LayoutCategory) {
    // COR
    LayoutCategory[LayoutCategory["COR"] = 1] = "COR";
    // ERR
    LayoutCategory[LayoutCategory["ERR"] = 2] = "ERR";
    // PAF
    LayoutCategory[LayoutCategory["PAF"] = 3] = "PAF";
    // PAS
    LayoutCategory[LayoutCategory["PAS"] = 4] = "PAS";
    // PEF
    LayoutCategory[LayoutCategory["PEF"] = 5] = "PEF";
    // SRF
    LayoutCategory[LayoutCategory["SRF"] = 6] = "SRF";
    // PEF-XIF0033
    LayoutCategory[LayoutCategory["PEFXIF0033"] = 9] = "PEFXIF0033";
    // INC
    LayoutCategory[LayoutCategory["INC"] = 12] = "INC";
    // CLM
    LayoutCategory[LayoutCategory["CLM"] = 14] = "CLM";
})(LayoutCategory || (LayoutCategory = {}));
//# sourceMappingURL=LayoutCategory.js.map